export default "__VITE_ASSET__BgtknE0u__"